// extracted by mini-css-extract-plugin
module.exports = {"PageVisual":"PageVisual_eUZH","iframe__container":"iframe__container_1BJZ","Video__wrapper":"Video__wrapper_dbwG"};